var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-container"},[_c('iframe',{attrs:{"title":"Reporte_BRF","width":"100%","height":"2000px","src":_vm.biURL,"frameborder":"0","allowFullScreen":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }